export enum WorkflowQueries {
  Requests = 'requests',
  ActiveRequests = 'activeRequests',
  FinishedRequests = 'finishedRequests',
  WorkflowIndicator = 'workflowIndicator',
}
